// extracted by mini-css-extract-plugin
export default {"CartContainer":"Cart_CartContainer__XOBKu","OrderSummary":"Cart_OrderSummary__D20+W"};